module.exports = __webpack_public_path__ + "img/_con2.c3e0c139.png";